// extracted by mini-css-extract-plugin
var _1 = "form-item__G3Fmy";
var _2 = "form-item-fill__mXoip";
var _3 = "form-modal__RWriK";
var _4 = "form-modal-item__LMsOG";
var _5 = "form-takeover__uO0uy";
var _6 = "form-takeover-item__kU7dl";
export { _1 as "formItem", _2 as "formItemFill", _3 as "formModal", _4 as "formModalItem", _5 as "formTakeover", _6 as "formTakeoverItem" }
